/* global APP, VietMeetJS, config, interfaceConfig */
import { vietmeetLocalStorage } from '@vietmeet/js-utils';
// @ts-ignore
import Logger from '@vietmeet/logger';
import { ENDPOINT_TEXT_MESSAGE_NAME } from './modules/API/constants';
import mediaDeviceHelper from './modules/devices/mediaDeviceHelper';
import Recorder from './modules/recorder/Recorder';
import ExternalShareReceiver from './modules/screenshare-cast/ExternalShareReceiver';
import { createTaskQueue } from './modules/util/helpers';
import { createDeviceChangedEvent, createScreenSharingEvent, createStartSilentEvent, createTrackMutedEvent } from './react/features/analytics/AnalyticsEvents';
import { sendAnalytics } from './react/features/analytics/functions';
import { maybeRedirectToWelcomePage, reloadWithStoredParams } from './react/features/app/actions';
import { _conferenceWillJoin, authStatusChanged, conferenceFailed, conferenceJoinInProgress, conferenceJoined, conferenceLeft, conferencePropertiesChanged, conferenceSubjectChanged, conferenceTimestampChanged, conferenceUniqueIdSet, conferenceWillInit, conferenceWillLeave, dataChannelClosed, dataChannelOpened, e2eRttChanged, endpointMessageReceived, kickedOut, lockStateChanged, nonParticipantMessageReceived, onStartMutedPolicyChanged, p2pStatusChanged } from './react/features/base/conference/actions';
import { AVATAR_URL_COMMAND, CONFERENCE_LEAVE_REASONS, EMAIL_COMMAND } from './react/features/base/conference/constants';
import { commonUserJoinedHandling, commonUserLeftHandling, getConferenceOptions, sendLocalParticipant, updateTrackMuteState } from './react/features/base/conference/functions';
import { getReplaceParticipant, getSsrcRewritingFeatureFlag } from './react/features/base/config/functions';
import { connect } from './react/features/base/connection/actions.web';
import { checkAndNotifyForNewDevice, getAvailableDevices, notifyCameraError, notifyMicError, updateDeviceList } from './react/features/base/devices/actions.web';
import { areDevicesDifferent, filterIgnoredDevices, flattenAvailableDevices, getDefaultDeviceId, logDevices, setAudioOutputDeviceId } from './react/features/base/devices/functions.web';
import { gumPending, setAudioAvailable, setAudioMuted, setAudioUnmutePermissions, setInitialGUMPromise, setVideoAvailable, setVideoMuted, setVideoUnmutePermissions } from './react/features/base/media/actions';
import { MEDIA_TYPE, VIDEO_MUTISM_AUTHORITY, VIDEO_TYPE } from './react/features/base/media/constants';
import { getStartWithAudioMuted, getStartWithVideoMuted, isVideoMutedByUser } from './react/features/base/media/functions';
import { IGUMPendingState } from './react/features/base/media/types';
import { dominantSpeakerChanged, localParticipantAudioLevelChanged, localParticipantRoleChanged, participantKicked, participantMutedUs, participantPresenceChanged, participantRoleChanged, participantSourcesUpdated, participantUpdated, screenshareParticipantDisplayNameChanged, updateRemoteParticipantFeatures } from './react/features/base/participants/actions';
import { getLocalParticipant, getNormalizedDisplayName, getParticipantByIdOrUndefined, getVirtualScreenshareParticipantByOwnerId } from './react/features/base/participants/functions';
import { updateSettings } from './react/features/base/settings/actions';
import { addLocalTrack, createInitialAVTracks, destroyLocalTracks, displayErrorsForCreateInitialLocalTracks, replaceLocalTrack, setGUMPendingStateOnFailedTracks, toggleScreensharing as toggleScreensharingA, trackAdded, trackRemoved } from './react/features/base/tracks/actions';
import { createLocalTracksF, getLocalVideoTrack, getLocalVietMeetAudioTrack, getLocalVietMeetVideoTrack, isLocalTrackMuted, isUserInteractionRequiredForUnmute } from './react/features/base/tracks/functions';
import { getLocalVietMeetAudioTrackSettings } from './react/features/base/tracks/functions.web';
import { downloadJSON } from './react/features/base/util/downloadJSON';
import { getVietMeetGlobalNSConnectionTimes } from './react/features/base/util/helpers';
import { VietMeetConferenceErrors, VietMeetConferenceEvents, VietMeetE2ePingEvents, VietMeetMediaDevicesEvents, VietMeetTrackEvents, browser } from './react/features/base/vietmeet-lib';
import { openLeaveReasonDialog } from './react/features/conference/actions.web';
import { appendSuffix } from './react/features/display-name/functions';
import { maybeOpenFeedbackDialog, submitFeedback } from './react/features/feedback/actions';
import { maybeSetLobbyChatMessageListener } from './react/features/lobby/actions.any';
import { setNoiseSuppressionEnabled } from './react/features/noise-suppression/actions';
import { hideNotification, showErrorNotification, showNotification, showWarningNotification } from './react/features/notifications/actions';
import { DATA_CHANNEL_CLOSED_NOTIFICATION_ID, NOTIFICATION_TIMEOUT_TYPE } from './react/features/notifications/constants';
import { suspendDetected } from './react/features/power-monitor/actions';
import { initPrejoin, isPrejoinPageVisible } from './react/features/prejoin/functions';
import { disableReceiver, stopReceiver } from './react/features/remote-control/actions';
import { setScreenAudioShareState } from './react/features/screen-share/actions.web';
import { isScreenAudioShared } from './react/features/screen-share/functions';
import { toggleScreenshotCaptureSummary } from './react/features/screenshot-capture/actions';
import { setAudioSettings } from './react/features/settings/actions.web';
import { AudioMixerEffect } from './react/features/stream-effects/audio-mixer/AudioMixerEffect';
import { createRnnoiseProcessor } from './react/features/stream-effects/rnnoise';
import { handleToggleVideoMuted } from './react/features/toolbox/actions.any';
import { transcriberJoined, transcriberLeft } from './react/features/transcribing/actions';
import { muteLocal } from './react/features/video-menu/actions.any';
const logger = Logger.getLogger('app:conference-web');
// @ts-ignore
let room;
/**
 * Known custom conference commands.
 */
const commands = {
    AVATAR_URL: AVATAR_URL_COMMAND,
    CUSTOM_ROLE: 'custom-role',
    EMAIL: EMAIL_COMMAND,
    ETHERPAD: 'etherpad'
};
/**
 * Share data to other users.
 * @param command the command
 * @param {string} value new value
 */
// @ts-ignore
function sendData(command, value) {
    // @ts-ignore
    if (!room) {
        return;
    }
    room.removeCommand(command);
    room.sendCommand(command, { value });
}
/**
 * A queue for the async replaceLocalTrack action so that multiple audio
 * replacements cannot happen simultaneously. This solves the issue where
 * replaceLocalTrack is called multiple times with an oldTrack of null, causing
 * multiple local tracks of the same type to be used.
 *
 * @private
 * @type {Object}
 */
const _replaceLocalAudioTrackQueue = createTaskQueue();
/**
 * A task queue for replacement local video tracks. This separate queue exists
 * so video replacement is not blocked by audio replacement tasks in the queue
 * {@link _replaceLocalAudioTrackQueue}.
 *
 * @private
 * @type {Object}
 */
const _replaceLocalVideoTrackQueue = createTaskQueue();
/**
 *
 */
class ConferenceConnector {
    /**
     *
     */
    // @ts-ignore
    constructor(resolve, reject, conference) {
        // @ts-ignore
        this._conference = conference;
        // @ts-ignore
        this._resolve = resolve;
        // @ts-ignore
        this._reject = reject;
        // @ts-ignore
        this.reconnectTimeout = null;
        // @ts-ignore
        room.on(VietMeetConferenceEvents.CONFERENCE_JOINED, this._handleConferenceJoined.bind(this));
        // @ts-ignore
        room.on(VietMeetConferenceEvents.CONFERENCE_FAILED, this._onConferenceFailed.bind(this));
    }
    /**
     *
     */
    // @ts-ignore
    _handleConferenceFailed(err) {
        this._unsubscribe();
        // @ts-ignore
        this._reject(err);
    }
    /**
     *
     */
    // @ts-ignore
    _onConferenceFailed(err, ...params) {
        // @ts-ignore
        APP.store.dispatch(conferenceFailed(room, err, ...params));
        logger.error('CONFERENCE FAILED:', err, ...params);
        switch (err) {
            case VietMeetConferenceErrors.RESERVATION_ERROR: {
                const [code, msg] = params;
                APP.store.dispatch(showErrorNotification({
                    descriptionArguments: {
                        code,
                        msg
                    },
                    descriptionKey: 'dialog.reservationErrorMsg',
                    titleKey: 'dialog.reservationError'
                }));
                break;
            }
            case VietMeetConferenceErrors.GRACEFUL_SHUTDOWN:
                APP.store.dispatch(showErrorNotification({
                    descriptionKey: 'dialog.gracefulShutdown',
                    titleKey: 'dialog.serviceUnavailable'
                }));
                break;
            // FIXME FOCUS_DISCONNECTED is a confusing event name.
            // What really happens there is that the library is not ready yet,
            // because Jicofo is not available, but it is going to give it another
            // try.
            case VietMeetConferenceErrors.FOCUS_DISCONNECTED: {
                const [focus, retrySec] = params;
                APP.store.dispatch(showNotification({
                    descriptionKey: focus,
                    titleKey: retrySec
                }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
                break;
            }
            case VietMeetConferenceErrors.FOCUS_LEFT:
            case VietMeetConferenceErrors.ICE_FAILED:
            case VietMeetConferenceErrors.VIDEOBRIDGE_NOT_AVAILABLE:
            case VietMeetConferenceErrors.OFFER_ANSWER_FAILED:
                // @ts-ignore
                APP.store.dispatch(conferenceWillLeave(room));
                // FIXME the conference should be stopped by the library and not by
                // the app. Both the errors above are unrecoverable from the library
                // perspective.
                // @ts-ignore
                room.leave(CONFERENCE_LEAVE_REASONS.UNRECOVERABLE_ERROR).then(() => APP.connection.disconnect());
                break;
            case VietMeetConferenceErrors.INCOMPATIBLE_SERVER_VERSIONS:
                APP.store.dispatch(reloadWithStoredParams());
                break;
            default:
                // @ts-ignore
                this._handleConferenceFailed(err, ...params);
        }
    }
    /**
     *
     */
    _unsubscribe() {
        // @ts-ignore
        room.off(VietMeetConferenceEvents.CONFERENCE_JOINED, this._handleConferenceJoined);
        // @ts-ignore
        room.off(VietMeetConferenceEvents.CONFERENCE_FAILED, this._onConferenceFailed);
        // @ts-ignore
        if (this.reconnectTimeout !== null) {
            // @ts-ignore
            clearTimeout(this.reconnectTimeout);
        }
    }
    /**
     *
     */
    _handleConferenceJoined() {
        this._unsubscribe();
        // @ts-ignore
        this._resolve();
    }
    /**
     *
     */
    connect() {
        const replaceParticipant = getReplaceParticipant(APP.store.getState());
        // the local storage overrides here and in connection.js can be used by jibri
        // @ts-ignore
        room.join(vietmeetLocalStorage.getItem('xmpp_conference_password_override'), replaceParticipant);
    }
}
/**
 * Disconnects the connection.
 * @returns resolved Promise. We need this in order to make the Promise.all
 * call in hangup() to resolve when all operations are finished.
 */
function disconnect() {
    const onDisconnected = () => {
        APP.API.notifyConferenceLeft(APP.conference.roomName);
        return Promise.resolve();
    };
    // @ts-ignore
    if (!APP.connection) {
        return onDisconnected();
    }
    // @ts-ignore
    return APP.connection.disconnect().then(onDisconnected, onDisconnected);
}
export default {
    /**
     * Flag used to delay modification of the muted status of local media tracks
     * until those are created (or not, but at that point it's certain that
     * the tracks won't exist).
     */
    _localTracksInitialized: false,
    /**
     * Flag used to prevent the creation of another local video track in this.muteVideo if one is already in progress.
     */
    isCreatingLocalTrack: false,
    isSharingScreen: false,
    /**
     * Returns an object containing a promise which resolves with the created tracks &
     * the errors resulting from that process.
     * @param {object} options
     * @param {boolean} option.isBreakoutRoom - true if we are creating the initial local tracks in breakout room.
     * @param {boolean} options.startLowBandwidthMode=false - if <tt>true</tt> then
     * only audio track will be created and the audio only mode will be turned
     * on.
     * @param {boolean} options.startScreenSharing=false - if <tt>true</tt>
     * should start with screensharing instead of camera video.
     * @param {boolean} options.startWithAudioMuted - will start the conference
     * without any audio tracks.
     * @param {boolean} options.startWithVideoMuted - will start the conference
     * without any video tracks.
     * @param {boolean} recordTimeMetrics - If true time metrics will be recorded.
     * @returns {Promise<VietMeetLocalTrack[]>, Object}
     */
    createInitialLocalTracks(options = {}, recordTimeMetrics = false) {
        const errors = {};
        // @ts-ignore
        const { isBreakoutRoom = false } = options;
        // Always get a handle on the audio input device so that we have statistics (such as "No audio input" or
        // "Are you trying to speak?" ) even if the user joins the conference muted.
        const initialDevices = config.startSilent || (config.disableInitialGUM && !isBreakoutRoom) ? [] : [MEDIA_TYPE.AUDIO];
        const requestedAudio = !config.disableInitialGUM || isBreakoutRoom;
        let requestedVideo = false;
        if ((!config.disableInitialGUM || isBreakoutRoom)
            // @ts-ignore
            && !options.startWithVideoMuted
            // @ts-ignore
            && !options.startLowBandwidthMode
            // @ts-ignore
            && !options.startScreenSharing) {
            initialDevices.push(MEDIA_TYPE.VIDEO);
            requestedVideo = true;
        }
        let tryCreateLocalTracks = Promise.resolve([]);
        // On Electron there is no permission prompt for granting permissions. That's why we don't need to
        // spend much time displaying the overlay screen. If GUM is not resolved within 15 seconds it will
        // probably never resolve.
        const timeout = browser.isElectron() ? 15000 : 60000;
        const audioOptions = {
            devices: [MEDIA_TYPE.AUDIO],
            timeout
        };
        // Spot uses the _desktopSharingSourceDevice config option to use an external video input device label as
        // screenshare and calls getUserMedia instead of getDisplayMedia for capturing the media.
        // @ts-ignore
        if (options.startScreenSharing && config._desktopSharingSourceDevice) {
            tryCreateLocalTracks = this._createDesktopTrack()
                .then(([desktopStream]) => {
                if (!requestedAudio) {
                    return [desktopStream];
                }
                return createLocalTracksF(audioOptions)
                    .then(([audioStream]) => [desktopStream, audioStream])
                    .catch(error => {
                    // @ts-ignore
                    errors.audioOnlyError = error;
                    return [desktopStream];
                });
            })
                .catch(error => {
                logger.error('Failed to obtain desktop stream', error);
                // @ts-ignore
                errors.screenSharingError = error;
                return requestedAudio ? createLocalTracksF(audioOptions) : [];
            })
                .catch(error => {
                // @ts-ignore
                errors.audioOnlyError = error;
                return [];
            });
        }
        else if (requestedAudio || requestedVideo) {
            tryCreateLocalTracks = APP.store.dispatch(createInitialAVTracks({
                devices: initialDevices,
                timeout
            }, recordTimeMetrics)).then(({ tracks, errors: pErrors }) => {
                Object.assign(errors, pErrors);
                return tracks;
            });
        }
        return {
            tryCreateLocalTracks,
            errors
        };
    },
    // @ts-ignore
    startConference(tracks) {
        // @ts-ignore
        tracks.forEach(track => {
            if ((track.isAudioTrack() && this.isLocalAudioMuted())
                || (track.isVideoTrack() && this.isLocalVideoMuted())) {
                const mediaType = track.getType();
                sendAnalytics(createTrackMutedEvent(mediaType, 'initial mute'));
                logger.log(`${mediaType} mute: initially muted.`);
                track.mute();
            }
        });
        this._createRoom(tracks);
        // if user didn't give access to mic or camera or doesn't have
        // them at all, we mark corresponding toolbar buttons as muted,
        // so that the user can try unmute later on and add audio/video
        // to the conference
        // @ts-ignore
        if (!tracks.find(t => t.isAudioTrack())) {
            this.updateAudioIconEnabled();
        }
        // @ts-ignore
        if (!tracks.find(t => t.isVideoTrack())) {
            this.setVideoMuteStatus();
        }
        if (config.iAmRecorder) {
            // @ts-ignore
            this.recorder = new Recorder();
        }
        if (config.startSilent) {
            sendAnalytics(createStartSilentEvent());
            APP.store.dispatch(showNotification({
                descriptionKey: 'notify.startSilentDescription',
                titleKey: 'notify.startSilentTitle'
            }, NOTIFICATION_TIMEOUT_TYPE.LONG));
        }
        // XXX The API will take care of disconnecting from the XMPP
        // server (and, thus, leaving the room) on unload.
        return new Promise((resolve, reject) => {
            new ConferenceConnector(resolve, reject, this).connect();
        });
    },
    /**
     * Open new connection and join the conference when prejoin page is not enabled.
     * If prejoin page is enabled open an new connection in the background
     * and create local tracks.
     *
     * @param {{ roomName: string, shouldDispatchConnect }} options
     * @returns {Promise}
     */
    // @ts-ignore
    async init({ roomName, shouldDispatchConnect }) {
        const state = APP.store.getState();
        const initialOptions = {
            startLowBandwidthMode: config.startLowBandwidthMode,
            startScreenSharing: config.startScreenSharing,
            startWithAudioMuted: getStartWithAudioMuted(state) || isUserInteractionRequiredForUnmute(state),
            startWithVideoMuted: getStartWithVideoMuted(state) || isUserInteractionRequiredForUnmute(state)
        };
        const connectionTimes = getVietMeetGlobalNSConnectionTimes();
        const startTime = window.performance.now();
        connectionTimes['conference.init.start'] = startTime;
        logger.debug(`Executed conference.init with roomName: ${roomName} (performance.now=${startTime})`);
        // @ts-ignore
        this.roomName = roomName;
        try {
            // Initialize the device list first. This way, when creating tracks based on preferred devices, loose label
            // matching can be done in cases where the exact ID match is no longer available, such as -
            // 1. When the camera device has switched USB ports.
            // 2. When in startSilent mode we want to start with audio muted
            await this._initDeviceList();
        }
        catch (error) {
            logger.warn('initial device list initialization failed', error);
        }
        // Filter out the local tracks based on various config options, i.e., when user joins muted or is muted by
        // focus. However, audio track will always be created even though it is not added to the conference since we
        // want audio related features (noisy mic, talk while muted, etc.) to work even if the mic is muted.
        // @ts-ignore
        const handleInitialTracks = (options, tracks) => {
            let localTracks = tracks;
            if (options.startWithAudioMuted) {
                // Always add the track on Safari because of a known issue where audio playout doesn't happen
                // if the user joins audio and video muted, i.e., if there is no local media capture.
                if (browser.isWebKitBased()) {
                    // @ts-ignore
                    this.muteAudio(true, true);
                }
                else {
                    // @ts-ignore
                    localTracks = localTracks.filter(track => {
                        if (track.getType() === MEDIA_TYPE.AUDIO) {
                            track.stopStream();
                            return false;
                        }
                        return true;
                    });
                }
            }
            return localTracks;
        };
        const { dispatch, getState } = APP.store;
        const createLocalTracksStart = window.performance.now();
        connectionTimes['conference.init.createLocalTracks.start'] = createLocalTracksStart;
        logger.debug(`(TIME) createInitialLocalTracks: ${createLocalTracksStart} `);
        const { tryCreateLocalTracks, errors } = this.createInitialLocalTracks(initialOptions, true);
        tryCreateLocalTracks.then(tr => {
            const createLocalTracksEnd = window.performance.now();
            connectionTimes['conference.init.createLocalTracks.end'] = createLocalTracksEnd;
            logger.debug(`(TIME) createInitialLocalTracks finished: ${createLocalTracksEnd} `);
            const tracks = handleInitialTracks(initialOptions, tr);
            this._initDeviceList(true);
            const { initialGUMPromise } = getState()['features/base/media'];
            if (isPrejoinPageVisible(getState())) {
                dispatch(gumPending([MEDIA_TYPE.AUDIO, MEDIA_TYPE.VIDEO], IGUMPendingState.NONE));
                // Since the conference is not yet created in redux this function will execute synchronous
                // which will guarantee us that the local tracks are added to redux before we proceed.
                initPrejoin(tracks, errors, dispatch);
                connectionTimes['conference.init.end'] = window.performance.now();
                // resolve the initialGUMPromise in case connect have finished so that we can proceed to join.
                if (initialGUMPromise) {
                    logger.debug('Resolving the initialGUM promise! (prejoinVisible=true)');
                    initialGUMPromise.resolve({
                        tracks,
                        errors
                    });
                }
                logger.debug('Clear the initialGUM promise! (prejoinVisible=true)');
                // For prejoin we don't need the initial GUM promise since the tracks are already added to the store
                // via initPrejoin
                dispatch(setInitialGUMPromise());
            }
            else {
                // @ts-ignore
                APP.store.dispatch(displayErrorsForCreateInitialLocalTracks(errors));
                setGUMPendingStateOnFailedTracks(tracks, APP.store.dispatch);
                connectionTimes['conference.init.end'] = window.performance.now();
                if (initialGUMPromise) {
                    logger.debug('Resolving the initialGUM promise!');
                    initialGUMPromise.resolve({
                        tracks,
                        errors
                    });
                }
            }
        });
        if (shouldDispatchConnect) {
            logger.info('Dispatching connect from init since prejoin is not visible.');
            dispatch(connect());
        }
    },
    /**
     * Check if id is id of the local user.
     * @param {string} id id to check
     * @returns {boolean}
     */
    // @ts-ignore
    isLocalId(id) {
        return this.getMyUserId() === id;
    },
    /**
     * Tells whether the local video is muted or not.
     * @return {boolean}
     */
    isLocalVideoMuted() {
        // If the tracks are not ready, read from base/media state
        return this._localTracksInitialized
            ? isLocalTrackMuted(APP.store.getState()['features/base/tracks'], MEDIA_TYPE.VIDEO)
            : isVideoMutedByUser(APP.store);
    },
    /**
     * Verify if there is an ongoing system audio sharing session and apply to the provided track
     * as a AudioMixer effect.
     *
     * @param {*} localAudioTrack - track to which system audio track will be applied as an effect, most likely
     * microphone local audio track.
     */
    // @ts-ignore
    async _maybeApplyAudioMixerEffect(localAudioTrack) {
        // At the time of writing this comment there were two separate flows for toggling screen-sharing
        // and system audio sharing, the first is the legacy method using the functionality from conference.js
        // the second is used when both sendMultipleVideoStreams and sourceNameSignaling flags are set to true.
        // The second flow uses functionality from base/conference/middleware.web.js.
        // We check if system audio sharing was done using the first flow by verifying this._desktopAudioStream and
        // for the second by checking 'features/screen-share' state.
        const { desktopAudioTrack } = APP.store.getState()['features/screen-share'];
        // @ts-ignore
        const currentDesktopAudioTrack = this._desktopAudioStream || desktopAudioTrack;
        // If system audio is already being sent, mix it with the provided audio track.
        if (currentDesktopAudioTrack) {
            // In case system audio sharing was done in the absence of an initial mic audio track, there is no
            // AudioMixerEffect so we have to remove system audio track from the room before setting it as an effect.
            // @ts-ignore
            await room.replaceTrack(currentDesktopAudioTrack, null);
            // @ts-ignore
            this._mixerEffect = new AudioMixerEffect(currentDesktopAudioTrack);
            logger.debug('Mixing new audio track with existing screen audio track.');
            // @ts-ignore
            await localAudioTrack.setEffect(this._mixerEffect);
        }
    },
    /**
     * Simulates toolbar button click for audio mute. Used by shortcuts and API.
     *
     * @param {boolean} mute true for mute and false for unmute.
     * dialogs in case of media permissions error.
     * @returns {Promise}
     */
    // @ts-ignore
    async muteAudio(mute) {
        const state = APP.store.getState();
        if (!mute
            && isUserInteractionRequiredForUnmute(state)) {
            logger.error('Unmuting audio requires user interaction');
            return;
        }
        await APP.store.dispatch(setAudioMuted(mute, true));
    },
    /**
     * Returns whether local audio is muted or not.
     * @returns {boolean}
     */
    isLocalAudioMuted() {
        // If the tracks are not ready, read from base/media state
        return this._localTracksInitialized
            ? isLocalTrackMuted(APP.store.getState()['features/base/tracks'], MEDIA_TYPE.AUDIO)
            : Boolean(APP.store.getState()['features/base/media'].audio.muted);
    },
    /**
     * Simulates toolbar button click for audio mute. Used by shortcuts
     * and API.
     * @param {boolean} [showUI] when set to false will not display any error
     * dialogs in case of media permissions error.
     */
    toggleAudioMuted(showUI = true) {
        // @ts-ignore
        this.muteAudio(!this.isLocalAudioMuted(), showUI);
    },
    /**
     * Simulates toolbar button click for video mute. Used by shortcuts and API.
     * @param mute true for mute and false for unmute.
     * dialogs in case of media permissions error.
     */
    // @ts-ignore
    muteVideo(mute) {
        const state = APP.store.getState();
        if (!mute
            && isUserInteractionRequiredForUnmute(state)) {
            logger.error('Unmuting video requires user interaction');
            return;
        }
        APP.store.dispatch(setVideoMuted(mute, VIDEO_MUTISM_AUTHORITY.USER, true));
    },
    /**
     * Simulates toolbar button click for video mute. Used by shortcuts and API.
     * @param {boolean} [showUI] when set to false will not display any error
     * dialogs in case of media permissions error.
     * @param {boolean} ensureTrack - True if we want to ensure that a new track is
     * created if missing.
     */
    toggleVideoMuted(showUI = true, ensureTrack = false) {
        const mute = !this.isLocalVideoMuted();
        APP.store.dispatch(handleToggleVideoMuted(mute, showUI, ensureTrack));
    },
    /**
     * Retrieve list of ids of conference participants (without local user).
     * @returns {string[]}
     */
    listMembersIds() {
        // @ts-ignore
        return room.getParticipants().map(p => p.getId());
    },
    /**
     * Checks whether the participant identified by id is a moderator.
     * @id id to search for participant
     * @return {boolean} whether the participant is moderator
     */
    // @ts-ignore
    isParticipantModerator(id) {
        // @ts-ignore
        const user = room.getParticipantById(id);
        return user?.isModerator();
    },
    /**
     * Retrieve list of conference participants (without local user).
     * @returns {VietMeetParticipant[]}
     *
     * NOTE: Used by vietmeet-torture!
     */
    listMembers() {
        // @ts-ignore
        return room.getParticipants();
    },
    /**
     * Used by Jibri to detect when it's alone and the meeting should be terminated.
     */
    get membersCount() {
        // @ts-ignore
        return room.getParticipants()
            // @ts-ignore
            .filter(p => !p.isHidden() || !(config.iAmRecorder && p.isHiddenFromRecorder())).length + 1;
    },
    /**
     * Get speaker stats that track total dominant speaker time.
     *
     * @returns {object} A hash with keys being user ids and values being the
     * library's SpeakerStats model used for calculating time as dominant
     * speaker.
     */
    getSpeakerStats() {
        // @ts-ignore
        return room.getSpeakerStats();
    },
    // used by torture currently
    isJoined() {
        // @ts-ignore
        return room?.isJoined();
    },
    getConnectionState() {
        // @ts-ignore
        return room?.getConnectionState();
    },
    /**
     * Obtains current P2P ICE connection state.
     * @return {string|null} ICE connection state or <tt>null</tt> if there's no
     * P2P connection
     */
    getP2PConnectionState() {
        // @ts-ignore
        return room?.getP2PConnectionState();
    },
    /**
     * Starts P2P (for tests only)
     * @private
     */
    _startP2P() {
        try {
            // @ts-ignore
            room?.startP2PSession();
        }
        catch (error) {
            logger.error('Start P2P failed', error);
            throw error;
        }
    },
    /**
     * Stops P2P (for tests only)
     * @private
     */
    _stopP2P() {
        try {
            // @ts-ignore
            room?.stopP2PSession();
        }
        catch (error) {
            logger.error('Stop P2P failed', error);
            throw error;
        }
    },
    /**
     * Checks whether or not our connection is currently in interrupted and
     * reconnect attempts are in progress.
     *
     * @returns {boolean} true if the connection is in interrupted state or
     * false otherwise.
     */
    isConnectionInterrupted() {
        // @ts-ignore
        return room.isConnectionInterrupted();
    },
    /**
     * Finds VietMeetParticipant for given id.
     *
     * @param {string} id participant's identifier(MUC nickname).
     *
     * @returns {VietMeetParticipant|null} participant instance for given id or
     * null if not found.
     */
    // @ts-ignore
    getParticipantById(id) {
        // @ts-ignore
        return room ? room.getParticipantById(id) : null;
    },
    getMyUserId() {
        // @ts-ignore
        return room?.myUserId();
    },
    /**
     * Will be filled with values only when config.testing.testMode is true.
     * Its used by torture to check audio levels.
     */
    audioLevelsMap: {},
    /**
     * Returns the stored audio level (stored only if config.debug is enabled)
     * @param id the id for the user audio level to return (the id value is
     *          returned for the participant using getMyUserId() method)
     */
    // @ts-ignore
    getPeerSSRCAudioLevel(id) {
        // @ts-ignore
        return this.audioLevelsMap[id];
    },
    /**
     * @return {number} the number of participants in the conference with at
     * least one track.
     */
    getNumberOfParticipantsWithTracks() {
        // @ts-ignore
        return room.getParticipants()
            // @ts-ignore
            .filter(p => p.getTracks().length > 0)
            .length;
    },
    /**
     * Returns the stats.
     */
    getStats() {
        // @ts-ignore
        return room.connectionQuality.getStats();
    },
    // end used by torture
    /**
     * Download logs, a function that can be called from console while
     * debugging.
     * @param filename (optional) specify target filename
     */
    saveLogs(filename = 'meetlog.json') {
        // this can be called from console and will not have reference to this
        // that's why we reference the global var
        // @ts-ignore
        const logs = APP.connection.getLogs();
        downloadJSON(logs, filename);
    },
    /**
     * Download app state, a function that can be called from console while debugging.
     * @param filename (optional) specify target filename
     */
    saveState(filename = 'meet-state.json') {
        downloadJSON(APP.store.getState(), filename);
    },
    /**
     * Sets multiple properties for the local participant in a single presence update.
     *
     * @param {Object} properties - Object of property names to values.
     * @param {boolean} [useRawKeys] - Skip the "jitsi_participant_" prefix when true.
     * @returns {void}
     */
    // @ts-ignore
    setLocalParticipantProperties(properties, useRawKeys = false) {
        // @ts-ignore
        if (!room) {
            logger.warn('Not setting participant properties, conference not initialized');
            return;
        }
        room.setLocalParticipantProperties(properties, useRawKeys);
    },
    /**
     * Exposes a Command(s) API on this instance. It is necessitated by (1) the
     * desire to keep room private to this instance and (2) the need of other
     * modules to send and receive commands to and from participants.
     * Eventually, this instance remains in control with respect to the
     * decision whether the Command(s) API of room (i.e. vietmeet-lib's
     * VietMeetConference) is to be used in the implementation of the Command(s)
     * API of this instance.
     */
    commands: {
        /**
         * Known custom conference commands.
         */
        defaults: commands,
        /**
         * Receives notifications from other participants about commands aka
         * custom events (sent by sendCommand or sendCommandOnce methods).
         * @param command {String} the name of the command
         * @param handler {Function} handler for the command
         */
        addCommandListener() {
            // eslint-disable-next-line prefer-rest-params
            // @ts-ignore
            // eslint-disable-next-line prefer-rest-params
            room.addCommandListener(...arguments);
        },
        /**
         * Removes command.
         * @param name {String} the name of the command.
         */
        removeCommand() {
            // eslint-disable-next-line prefer-rest-params
            // @ts-ignore
            // eslint-disable-next-line prefer-rest-params
            room.removeCommand(...arguments);
        },
        /**
         * Sends command.
         * @param name {String} the name of the command.
         * @param values {Object} with keys and values that will be sent.
         */
        sendCommand() {
            // eslint-disable-next-line prefer-rest-params
            // @ts-ignore
            // eslint-disable-next-line prefer-rest-params
            room.sendCommand(...arguments);
        },
        /**
         * Sends command one time.
         * @param name {String} the name of the command.
         * @param values {Object} with keys and values that will be sent.
         */
        sendCommandOnce() {
            // eslint-disable-next-line prefer-rest-params
            // @ts-ignore
            // eslint-disable-next-line prefer-rest-params
            room.sendCommandOnce(...arguments);
        }
    },
    /**
     * Used by the Breakout Rooms feature to join a breakout room or go back to the main room.
     */
    // @ts-ignore
    async joinRoom(roomName, options) {
        APP.store.dispatch(conferenceWillInit());
        // Restore initial state.
        this._localTracksInitialized = false;
        // @ts-ignore
        this.roomName = roomName;
        const { tryCreateLocalTracks, errors } = this.createInitialLocalTracks(options);
        const localTracks = await tryCreateLocalTracks;
        // @ts-ignore
        APP.store.dispatch(displayErrorsForCreateInitialLocalTracks(errors));
        localTracks.forEach(track => {
            // @ts-ignore
            if ((track.isAudioTrack() && this.isLocalAudioMuted())
                // @ts-ignore
                || (track.isVideoTrack() && this.isLocalVideoMuted())) {
                // @ts-ignore
                track.mute();
            }
        });
        this._createRoom(localTracks);
        return new Promise((resolve, reject) => {
            new ConferenceConnector(resolve, reject, this).connect();
        });
    },
    // @ts-ignore
    _createRoom(localTracks) {
        // @ts-ignore
        room = APP.connection.initVietMeetConference(APP.conference.roomName, this._getConferenceOptions());
        // Filter out the tracks that are muted (except on Safari).
        let tracks = localTracks;
        if (!browser.isWebKitBased()) {
            // @ts-ignore
            const mutedTrackTypes = [];
            // @ts-ignore
            tracks = localTracks.filter(track => {
                if (!track.isMuted()) {
                    return true;
                }
                if (track.getVideoType() !== VIDEO_TYPE.DESKTOP) {
                    mutedTrackTypes.push(track.getType());
                }
                return false;
            });
            // @ts-ignore
            APP.store.dispatch(gumPending(mutedTrackTypes, IGUMPendingState.NONE));
        }
        // @ts-ignore
        this._room = room; // FIXME do not use this
        APP.store.dispatch(_conferenceWillJoin(room));
        this._setLocalAudioVideoStreams(tracks);
        sendLocalParticipant(APP.store, room);
        this._setupListeners();
    },
    /**
     * Sets local video and audio streams.
     * @param {VietMeetLocalTrack[]} tracks=[]
     * @returns {Promise[]}
     * @private
     */
    _setLocalAudioVideoStreams(tracks = []) {
        const { dispatch } = APP.store;
        // @ts-ignore
        const pendingGUMDevicesToRemove = [];
        const promises = tracks.map(track => {
            // @ts-ignore
            if (track.isAudioTrack()) {
                pendingGUMDevicesToRemove.push(MEDIA_TYPE.AUDIO);
                return this.useAudioStream(track);
                // @ts-ignore
            }
            else if (track.isVideoTrack()) {
                logger.debug(`_setLocalAudioVideoStreams is calling useVideoStream with track: ${track}`);
                pendingGUMDevicesToRemove.push(MEDIA_TYPE.VIDEO);
                return this.useVideoStream(track);
            }
            logger.error('Ignored not an audio nor a video track: ', track);
            return Promise.resolve();
        });
        return Promise.allSettled(promises).then(() => {
            if (pendingGUMDevicesToRemove.length > 0) {
                // @ts-ignore
                dispatch(gumPending(pendingGUMDevicesToRemove, IGUMPendingState.NONE));
            }
            this._localTracksInitialized = true;
            logger.log(`Initialized with ${tracks.length} local tracks`);
        });
    },
    _getConferenceOptions() {
        const options = getConferenceOptions(APP.store.getState());
        options.createVADProcessor = createRnnoiseProcessor;
        return options;
    },
    /**
     * Start using provided video stream.
     * Stops previous video stream.
     * @param {VietMeetLocalTrack} newTrack - new track to use or null
     * @returns {Promise}
     */
    // @ts-ignore
    useVideoStream(newTrack) {
        logger.debug(`useVideoStream: ${newTrack}`);
        return new Promise((resolve, reject) => {
            // @ts-ignore
            _replaceLocalVideoTrackQueue.enqueue(onFinish => {
                const state = APP.store.getState();
                const oldTrack = getLocalVietMeetVideoTrack(state);
                logger.debug(`useVideoStream: Replacing ${oldTrack} with ${newTrack}`);
                if (oldTrack === newTrack || (!oldTrack && !newTrack)) {
                    // @ts-ignore
                    resolve();
                    onFinish();
                    return;
                }
                // Add the track to the conference if there is no existing track, replace it otherwise.
                const trackAction = oldTrack
                    // @ts-ignore
                    ? replaceLocalTrack(oldTrack, newTrack, room)
                    : addLocalTrack(newTrack);
                // @ts-ignore
                APP.store.dispatch(trackAction)
                    .then(() => {
                    this.setVideoMuteStatus();
                })
                    .then(resolve)
                    .catch(error => {
                    logger.error(`useVideoStream failed: ${error}`);
                    reject(error);
                })
                    .then(onFinish);
            });
        });
    },
    /**
     * Start using provided audio stream.
     * Stops previous audio stream.
     * @param {VietMeetLocalTrack} newTrack - new track to use or null
     * @returns {Promise}
     */
    // @ts-ignore
    useAudioStream(newTrack) {
        return new Promise((resolve, reject) => {
            // @ts-ignore
            _replaceLocalAudioTrackQueue.enqueue(onFinish => {
                const oldTrack = getLocalVietMeetAudioTrack(APP.store.getState());
                if (oldTrack === newTrack) {
                    // @ts-ignore
                    resolve();
                    onFinish();
                    return;
                }
                // @ts-ignore
                APP.store.dispatch(replaceLocalTrack(oldTrack, newTrack, room))
                    .then(() => {
                    this.updateAudioIconEnabled();
                })
                    .then(resolve)
                    .catch(reject)
                    .then(onFinish);
            });
        });
    },
    /**
     * Returns whether or not the conference is currently in audio only mode.
     *
     * @returns {boolean}
     */
    isLowBandwidthMode() {
        return Boolean(APP.store.getState()['features/base/low-bandwidth-mode'].enabled);
    },
    /**
     * This fields stores a handler which will create a Promise which turns off
     * the screen sharing and restores the previous video state (was there
     * any video, before switching to screen sharing ? was it muted ?).
     *
     * Once called this fields is cleared to <tt>null</tt>.
     * @type {Function|null}
     */
    _untoggleScreenSharing: null,
    /**
     * Creates a Promise which turns off the screen sharing and restores
     * the previous state described by the arguments.
     *
     * This method is bound to the appropriate values, after switching to screen
     * sharing and stored in {@link _untoggleScreenSharing}.
     *
     * @param {boolean} didHaveVideo indicates if there was a camera video being
     * used, before switching to screen sharing.
     * @param {boolean} ignoreDidHaveVideo indicates if the camera video should be
     * ignored when switching screen sharing off.
     * @return {Promise} resolved after the screen sharing is turned off, or
     * rejected with some error (no idea what kind of error, possible GUM error)
     * in case it fails.
     * @private
     */
    // @ts-ignore
    async _turnScreenSharingOff(didHaveVideo, ignoreDidHaveVideo) {
        this._untoggleScreenSharing = null;
        APP.store.dispatch(stopReceiver());
        this._stopProxyConnection();
        this._stopExternalShare();
        APP.store.dispatch(toggleScreenshotCaptureSummary(false));
        const tracks = APP.store.getState()['features/base/tracks'];
        const duration = getLocalVideoTrack(tracks)?.vietmeetTrack.getDuration() ?? 0;
        // If system audio was also shared stop the AudioMixerEffect and dispose of the desktop audio track.
        // @ts-ignore
        if (this._mixerEffect) {
            const localAudio = getLocalVietMeetAudioTrack(APP.store.getState());
            await localAudio.setEffect(undefined);
            // @ts-ignore
            await this._desktopAudioStream.dispose();
            // @ts-ignore
            this._mixerEffect = undefined;
            // @ts-ignore
            this._desktopAudioStream = undefined;
            // In case there was no local audio when screen sharing was started the fact that we set the audio stream to
            // null will take care of the desktop audio stream cleanup.
            // @ts-ignore
        }
        else if (this._desktopAudioStream) {
            // @ts-ignore
            await room.replaceTrack(this._desktopAudioStream, null);
            // @ts-ignore
            this._desktopAudioStream.dispose();
            // @ts-ignore
            this._desktopAudioStream = undefined;
        }
        APP.store.dispatch(setScreenAudioShareState(false));
        let promise;
        if (didHaveVideo && !ignoreDidHaveVideo) {
            promise = createLocalTracksF({ devices: ['video'] })
                .then(([stream]) => {
                logger.debug(`_turnScreenSharingOff using ${stream} for useVideoStream`);
                return this.useVideoStream(stream);
            })
                .catch(error => {
                logger.error('failed to switch back to local video', error);
                return this.useVideoStream(null).then(() => 
                // Still fail with the original err
                Promise.reject(error));
            });
        }
        else {
            promise = this.useVideoStream(null);
        }
        return promise.then(() => {
            sendAnalytics(createScreenSharingEvent('stopped', duration === 0 ? null : duration));
            logger.info('Screen sharing stopped.');
        }, error => {
            logger.error(`_turnScreenSharingOff failed: ${error}`);
            throw error;
        });
    },
    /**
     * Creates desktop (screensharing) {@link VietMeetLocalTrack}
     *
     * @return {Promise.<VietMeetLocalTrack>} - A Promise resolved with
     * {@link VietMeetLocalTrack} for the screensharing or rejected with
     * {@link VietMeetTrackError}.
     *
     * @private
     */
    _createDesktopTrack() {
        const didHaveVideo = !this.isLocalVideoMuted();
        const getDesktopStreamPromise = createLocalTracksF({
            desktopSharingSourceDevice: config._desktopSharingSourceDevice,
            devices: ['desktop']
        });
        return getDesktopStreamPromise.then(desktopStreams => {
            // Stores the "untoggle" handler which remembers whether was
            // there any video before and whether was it muted.
            // @ts-ignore
            this._untoggleScreenSharing
                = this._turnScreenSharingOff.bind(this, didHaveVideo);
            // @ts-ignore
            const desktopAudioStream = desktopStreams.find(stream => stream.getType() === MEDIA_TYPE.AUDIO);
            if (desktopAudioStream) {
                desktopAudioStream.on(VietMeetTrackEvents.LOCAL_TRACK_STOPPED, () => {
                    logger.debug('Local screensharing audio track stopped.');
                    // Handle case where screen share was stopped from  the browsers 'screen share in progress'
                    // window. If audio screen sharing is stopped via the normal UX flow this point shouldn't
                    // be reached.
                    isScreenAudioShared(APP.store.getState())
                        && this._untoggleScreenSharing?.();
                });
            }
            return desktopStreams;
        }, error => {
            throw error;
        });
    },
    /**
     * Setup interaction between conference and UI.
     */
    _setupListeners() {
        // add local streams when joined to the conference
        // @ts-ignore
        room.on(VietMeetConferenceEvents.CONFERENCE_JOINED, () => {
            this._onConferenceJoined();
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.CONFERENCE_JOIN_IN_PROGRESS, 
        // @ts-ignore
        () => APP.store.dispatch(conferenceJoinInProgress(room)));
        // @ts-ignore
        room.on(VietMeetConferenceEvents.CONFERENCE_LEFT, 
        // @ts-ignore
        (...args) => {
            APP.store.dispatch(conferenceTimestampChanged(0));
            // @ts-ignore
            APP.store.dispatch(conferenceLeft(room, ...args));
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.CONFERENCE_UNIQUE_ID_SET, 
        // @ts-ignore
        (...args) => {
            // Preserve the sessionId so that the value is accessible even after room
            // is disconnected.
            // @ts-ignore
            room.sessionId = room.getMeetingUniqueId();
            // @ts-ignore
            APP.store.dispatch(conferenceUniqueIdSet(room, ...args));
        });
        // we want to ignore this event in case of tokenAuthUrl config
        // we are deprecating this and at some point will get rid of it
        if (!config.tokenAuthUrl) {
            // @ts-ignore
            room.on(VietMeetConferenceEvents.AUTH_STATUS_CHANGED, 
            // @ts-ignore
            (authEnabled, authLogin) => APP.store.dispatch(authStatusChanged(authEnabled, authLogin)));
        }
        // @ts-ignore
        room.on(VietMeetConferenceEvents.PARTCIPANT_FEATURES_CHANGED, user => {
            APP.store.dispatch(updateRemoteParticipantFeatures(user));
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.USER_JOINED, (id, user) => {
            if (config.iAmRecorder && user.isHiddenFromRecorder()) {
                return;
            }
            // A participant whose video is hidden from the recorder is handled like a hidden participant: it is not
            // added to the state, so it gets no tile. Its audio tracks are still added (see TRACK_ADDED below), and
            // they are played and recorded. The optional call keeps this working with a vietmeet-lib release
            // which does not have the method yet.
            const videoHiddenFromRecorder = config.iAmRecorder && user.isVideoHiddenFromRecorder?.();
            if (!videoHiddenFromRecorder) {
                // The logic shared between RN and web.
                // @ts-ignore
                commonUserJoinedHandling(APP.store, room, user);
            }
            if (user.isHidden() || videoHiddenFromRecorder) {
                return;
            }
            APP.store.dispatch(updateRemoteParticipantFeatures(user));
            logger.log(`USER ${id} connected`);
            APP.UI.addUser(user);
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.USER_LEFT, (id, user) => {
            const videoHiddenFromRecorder = config.iAmRecorder && user.isVideoHiddenFromRecorder?.();
            if (!videoHiddenFromRecorder) {
                // The logic shared between RN and web.
                // @ts-ignore
                commonUserLeftHandling(APP.store, room, user);
            }
            if (user.isHidden() || videoHiddenFromRecorder) {
                return;
            }
            logger.log(`USER ${id} LEFT:`, user);
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.USER_STATUS_CHANGED, (id, status) => {
            APP.store.dispatch(participantPresenceChanged(id, status));
            // @ts-ignore
            const user = room.getParticipantById(id);
            if (user) {
                APP.UI.updateUserStatus(user, status);
            }
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.USER_ROLE_CHANGED, (id, role) => {
            if (this.isLocalId(id)) {
                logger.info(`My role changed, new role: ${role}`);
                if (role === 'moderator') {
                    APP.store.dispatch(maybeSetLobbyChatMessageListener());
                }
                APP.store.dispatch(localParticipantRoleChanged(role));
            }
            else {
                APP.store.dispatch(participantRoleChanged(id, role));
            }
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.TRACK_ADDED, track => {
            if (!track || track.isLocal()) {
                return;
            }
            if (config.iAmRecorder) {
                // @ts-ignore
                const participant = room.getParticipantById(track.getParticipantId());
                if (participant.isHiddenFromRecorder()) {
                    return;
                }
                // Only the video of this participant is hidden from the recorder. Its audio is still recorded.
                if (participant.isVideoHiddenFromRecorder?.() && track.isVideoTrack()) {
                    return;
                }
            }
            APP.store.dispatch(trackAdded(track));
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.TRACK_REMOVED, track => {
            if (!track || track.isLocal()) {
                return;
            }
            APP.store.dispatch(trackRemoved(track));
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.TRACK_AUDIO_LEVEL_CHANGED, (id, lvl) => {
            const localAudio = getLocalVietMeetAudioTrack(APP.store.getState());
            let newLvl = lvl;
            if (this.isLocalId(id)) {
                APP.store.dispatch(localParticipantAudioLevelChanged(lvl));
            }
            if (this.isLocalId(id) && localAudio?.isMuted()) {
                newLvl = 0;
            }
            if (config.testing?.testMode) {
                // @ts-ignore
                this.audioLevelsMap[id] = newLvl;
                if (config.testing?.debugAudioLevels) {
                    logger.log(`AudioLevel:${id}/${newLvl}`);
                }
            }
            APP.UI.setAudioLevel(id, newLvl);
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.TRACK_MUTE_CHANGED, (track, participantThatMutedUs) => {
            if (participantThatMutedUs) {
                APP.store.dispatch(participantMutedUs(participantThatMutedUs, track));
            }
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.TRACK_UNMUTE_REJECTED, track => APP.store.dispatch(destroyLocalTracks(track)));
        // @ts-ignore
        room.on(VietMeetConferenceEvents.SUBJECT_CHANGED, 
        // @ts-ignore
        subject => APP.store.dispatch(conferenceSubjectChanged(subject)));
        // @ts-ignore
        room.on(VietMeetConferenceEvents.LAST_N_ENDPOINTS_CHANGED, 
        // @ts-ignore
        (leavingIds, enteringIds) => APP.UI.handleLastNEndpoints(leavingIds, enteringIds));
        // @ts-ignore
        room.on(VietMeetConferenceEvents.P2P_STATUS, 
        // @ts-ignore
        (vietmeetConference, p2p) => APP.store.dispatch(p2pStatusChanged(p2p)));
        // @ts-ignore
        room.on(VietMeetConferenceEvents.DOMINANT_SPEAKER_CHANGED, 
        // @ts-ignore
        (dominant, previous, silence) => {
            // @ts-ignore
            APP.store.dispatch(dominantSpeakerChanged(dominant, previous, Boolean(silence), room));
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.CONFERENCE_CREATED_TIMESTAMP, 
        // @ts-ignore
        conferenceTimestamp => {
            APP.store.dispatch(conferenceTimestampChanged(conferenceTimestamp));
            APP.API.notifyConferenceCreatedTimestamp(conferenceTimestamp);
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.DISPLAY_NAME_CHANGED, 
        // @ts-ignore
        (id, displayName) => {
            const formattedDisplayName = getNormalizedDisplayName(displayName);
            const state = APP.store.getState();
            const { defaultRemoteDisplayName } = state['features/base/config'];
            APP.store.dispatch(participantUpdated({
                // @ts-ignore
                conference: room,
                id,
                name: formattedDisplayName
            }));
            const virtualScreenshareParticipantId = getVirtualScreenshareParticipantByOwnerId(state, id)?.id;
            if (virtualScreenshareParticipantId) {
                APP.store.dispatch(
                // @ts-ignore
                screenshareParticipantDisplayNameChanged(virtualScreenshareParticipantId, formattedDisplayName));
            }
            APP.API.notifyDisplayNameChanged(id, {
                displayName: formattedDisplayName,
                formattedDisplayName: appendSuffix(
                // @ts-ignore
                formattedDisplayName
                    || defaultRemoteDisplayName)
            });
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.SILENT_STATUS_CHANGED, 
        // @ts-ignore
        (id, isSilent) => {
            APP.store.dispatch(participantUpdated({
                // @ts-ignore
                conference: room,
                id,
                isSilent
            }));
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.BOT_TYPE_CHANGED, 
        // @ts-ignore
        (id, botType) => {
            APP.store.dispatch(participantUpdated({
                // @ts-ignore
                conference: room,
                id,
                botType
            }));
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.TRANSCRIPTION_STATUS_CHANGED, 
        // @ts-ignore
        (status, id, abruptly) => {
            if (status === VietMeetJS.constants.transcriptionStatus.ON) {
                APP.store.dispatch(transcriberJoined(id));
            }
            else if (status === VietMeetJS.constants.transcriptionStatus.OFF) {
                APP.store.dispatch(transcriberLeft(id, abruptly));
            }
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.ENDPOINT_MESSAGE_RECEIVED, 
        // @ts-ignore
        (participant, data) => {
            APP.store.dispatch(endpointMessageReceived(participant, data));
            if (data?.name === ENDPOINT_TEXT_MESSAGE_NAME) {
                APP.API.notifyEndpointTextMessageReceived({
                    senderInfo: {
                        jid: participant.getJid(),
                        id: participant.getId()
                    },
                    eventData: data
                });
            }
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.NON_PARTICIPANT_MESSAGE_RECEIVED, 
        // @ts-ignore
        (id, data) => {
            APP.store.dispatch(nonParticipantMessageReceived(id, data));
            APP.API.notifyNonParticipantMessageReceived(id, data);
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.LOCK_STATE_CHANGED, 
        // @ts-ignore
        (...args) => APP.store.dispatch(lockStateChanged(room, ...args)));
        // @ts-ignore
        room.on(VietMeetConferenceEvents.PROPERTIES_CHANGED, 
        // @ts-ignore
        properties => APP.store.dispatch(conferencePropertiesChanged(properties)));
        // @ts-ignore
        room.on(VietMeetConferenceEvents.KICKED, (participant, reason, isReplaced) => {
            if (isReplaced) {
                // this event triggers when the local participant is kicked, `participant`
                // is the kicker. In replace participant case, kicker is undefined,
                // as the server initiated it. We mark in store the local participant
                // as being replaced based on jwt.
                const localParticipant = getLocalParticipant(APP.store.getState());
                APP.store.dispatch(participantUpdated({
                    // @ts-ignore
                    conference: room,
                    // @ts-ignore
                    id: localParticipant.id,
                    isReplaced
                }));
                // we send readyToClose when kicked participant is replace so that
                // embedding app can choose to dispose the iframe API on the handler.
                APP.API.notifyReadyToClose();
            }
            // @ts-ignore
            APP.store.dispatch(kickedOut(room, participant));
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.PARTICIPANT_KICKED, (kicker, kicked) => {
            APP.store.dispatch(participantKicked(kicker, kicked));
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.PARTICIPANT_SOURCE_UPDATED, 
        // @ts-ignore
        vietmeetParticipant => {
            APP.store.dispatch(participantSourcesUpdated(vietmeetParticipant));
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.SUSPEND_DETECTED, () => {
            APP.store.dispatch(suspendDetected());
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.AUDIO_UNMUTE_PERMISSIONS_CHANGED, 
        // @ts-ignore
        disableAudioMuteChange => {
            APP.store.dispatch(setAudioUnmutePermissions(disableAudioMuteChange));
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.VIDEO_UNMUTE_PERMISSIONS_CHANGED, 
        // @ts-ignore
        disableVideoMuteChange => {
            APP.store.dispatch(setVideoUnmutePermissions(disableVideoMuteChange));
        });
        // @ts-ignore
        room.on(VietMeetE2ePingEvents.E2E_RTT_CHANGED, 
        // @ts-ignore
        (...args) => APP.store.dispatch(e2eRttChanged(...args)));
        // @ts-ignore
        room.addCommandListener(this.commands.defaults.EMAIL, (data, from) => {
            APP.store.dispatch(participantUpdated({
                // @ts-ignore
                conference: room,
                id: from,
                email: data.value
            }));
        });
        // @ts-ignore
        room.addCommandListener(this.commands.defaults.AVATAR_URL, 
        // @ts-ignore
        (data, from) => {
            const participant = getParticipantByIdOrUndefined(APP.store, from);
            // if already set from presence(jwt), skip the command processing
            if (!participant?.avatarURL) {
                APP.store.dispatch(participantUpdated({
                    // @ts-ignore
                    conference: room,
                    id: from,
                    avatarURL: data.value
                }));
            }
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.START_MUTED_POLICY_CHANGED, 
        // @ts-ignore
        ({ audio, video }) => {
            APP.store.dispatch(onStartMutedPolicyChanged(audio, video));
            const state = APP.store.getState();
            updateTrackMuteState(state, APP.store.dispatch, true);
            updateTrackMuteState(state, APP.store.dispatch, false);
        });
        // @ts-ignore
        room.on(VietMeetConferenceEvents.DATA_CHANNEL_OPENED, () => {
            APP.store.dispatch(dataChannelOpened());
            APP.store.dispatch(hideNotification(DATA_CHANNEL_CLOSED_NOTIFICATION_ID));
        });
        // @ts-ignore
        room.on(
        // @ts-ignore
        VietMeetConferenceEvents.DATA_CHANNEL_CLOSED, ev => {
            const state = APP.store.getState();
            const { dataChannelOpen } = state['features/base/conference'];
            const timeout = typeof dataChannelOpen === 'undefined' ? 15000 : 60000;
            // Show the notification only when the data channel connection doesn't get re-established in 60 secs if
            // it was already established at the beginning of the call, show it sooner otherwise. This notification
            // can be confusing and alarming to users even when there is no significant impact to user experience
            // if the the reconnect happens immediately.
            setTimeout(() => {
                const { dataChannelOpen: open } = APP.store.getState()['features/base/conference'];
                if (!open) {
                    const descriptionKey = getSsrcRewritingFeatureFlag(state)
                        ? 'notify.dataChannelClosedDescriptionWithAudio' : 'notify.dataChannelClosedDescription';
                    const titleKey = getSsrcRewritingFeatureFlag(state)
                        ? 'notify.dataChannelClosedWithAudio' : 'notify.dataChannelClosed';
                    APP.store.dispatch(dataChannelClosed(ev.code, ev.reason));
                    APP.store.dispatch(showWarningNotification({
                        descriptionKey,
                        titleKey,
                        uid: DATA_CHANNEL_CLOSED_NOTIFICATION_ID
                    }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
                }
            }, timeout);
        });
    },
    /**
     * Handles audio device changes.
     *
     * @param {string} cameraDeviceId - The new device id.
     * @returns {Promise}
     */
    // @ts-ignore
    async onAudioDeviceChanged(micDeviceId) {
        const audioWasMuted = this.isLocalAudioMuted();
        // Disable noise suppression if it was enabled on the previous track.
        await APP.store.dispatch(setNoiseSuppressionEnabled(false));
        // When the 'default' mic needs to be selected, we need to pass the real device id to gUM instead of
        // 'default' in order to get the correct MediaStreamTrack from chrome because of the following bug.
        // https://bugs.chromium.org/p/chromium/issues/detail?id=997689.
        const isDefaultMicSelected = micDeviceId === 'default';
        const selectedDeviceId = isDefaultMicSelected
            ? getDefaultDeviceId(APP.store.getState(), 'audioInput')
            : micDeviceId;
        logger.info(`Switching audio input device to ${selectedDeviceId}`);
        sendAnalytics(createDeviceChangedEvent('audio', 'input'));
        createLocalTracksF({
            devices: ['audio'],
            micDeviceId: selectedDeviceId
        })
            .then(([stream]) => {
            // if audio was muted before changing the device, mute
            // with the new device
            if (audioWasMuted) {
                return stream.mute()
                    .then(() => stream);
            }
            return stream;
        })
            .then(async (stream) => {
            await this._maybeApplyAudioMixerEffect(stream);
            return this.useAudioStream(stream);
        })
            .then(() => {
            const state = APP.store.getState();
            const localAudio = getLocalVietMeetAudioTrack(state);
            const settings = getLocalVietMeetAudioTrackSettings(state);
            APP.store.dispatch(setAudioSettings(settings));
            if (localAudio && isDefaultMicSelected) {
                // workaround for the default device to be shown as selected in the
                // settings even when the real device id was passed to gUM because of the
                // above mentioned chrome bug.
                localAudio._realDeviceId = localAudio.deviceId = 'default';
            }
        })
            .catch(err => {
            logger.error(`Failed to switch to selected audio input device ${selectedDeviceId}, error=${err}`);
            APP.store.dispatch(notifyMicError(err));
        });
    },
    /**
     * Handles video device changes.
     *
     * @param {string} cameraDeviceId - The new device id.
     * @returns {void}
     */
    // @ts-ignore
    onVideoDeviceChanged(cameraDeviceId) {
        const videoWasMuted = this.isLocalVideoMuted();
        const localVideoTrack = getLocalVietMeetVideoTrack(APP.store.getState());
        if (localVideoTrack?.getDeviceId() === cameraDeviceId) {
            return;
        }
        sendAnalytics(createDeviceChangedEvent('video', 'input'));
        createLocalTracksF({
            devices: ['video'],
            cameraDeviceId
        })
            .then(([stream]) => {
            // if we are in audio only mode or video was muted before
            // changing device, then mute
            if (this.isLowBandwidthMode() || videoWasMuted) {
                return stream.mute()
                    .then(() => stream);
            }
            return stream;
        })
            .then(stream => {
            logger.info(`Switching the local video device to ${cameraDeviceId}.`);
            return this.useVideoStream(stream);
        })
            .catch(error => {
            logger.error(`Failed to switch to selected camera:${cameraDeviceId}, error:${error}`);
            return APP.store.dispatch(notifyCameraError(error));
        });
    },
    /**
     * Handles audio only changes.
     */
    onToggleLowBandwidthMode() {
        // Immediately update the UI by having remote videos and the large video update themselves.
        const displayedUserId = APP.UI.getLargeVideoID();
        if (displayedUserId) {
            APP.UI.updateLargeVideo(displayedUserId, true);
        }
    },
    /**
     * Cleanups local conference on suspend.
     */
    onSuspendDetected() {
        // After wake up, we will be in a state where conference is left
        // there will be dialog shown to user.
        // We do not want video/audio as we show an overlay and after it
        // user need to rejoin or close, while waking up we can detect
        // camera wakeup as a problem with device.
        // We also do not care about device change, which happens
        // on resume after suspending PC.
        // @ts-ignore
        if (this.deviceChangeListener) {
            VietMeetJS.mediaDevices.removeEventListener(VietMeetMediaDevicesEvents.DEVICE_LIST_CHANGED, 
            // @ts-ignore
            this.deviceChangeListener);
        }
    },
    /**
     * Callback invoked when the conference has been successfully joined.
     * Initializes the UI and various other features.
     *
     * @private
     * @returns {void}
     */
    _onConferenceJoined() {
        const { dispatch } = APP.store;
        APP.UI.initConference();
        // @ts-ignore
        dispatch(conferenceJoined(room));
        const jwt = APP.store.getState()['features/base/jwt'];
        // @ts-ignore
        if (jwt?.user?.hiddenFromRecorder) {
            dispatch(muteLocal(true, MEDIA_TYPE.AUDIO));
            dispatch(muteLocal(true, MEDIA_TYPE.VIDEO));
            dispatch(setAudioUnmutePermissions(true, true));
            dispatch(setVideoUnmutePermissions(true, true));
        }
    },
    /**
     * Updates the list of current devices.
     * @param {boolean} setDeviceListChangeHandler - Whether to add the deviceList change handlers.
     * @private
     * @returns {Promise}
     */
    _initDeviceList(setDeviceListChangeHandler = false) {
        const { mediaDevices } = VietMeetJS;
        if (mediaDevices.isDeviceChangeAvailable()) {
            if (setDeviceListChangeHandler) {
                // @ts-ignore
                this.deviceChangeListener = devices => window.setTimeout(() => this._onDeviceListChanged(devices), 0);
                mediaDevices.addEventListener(VietMeetMediaDevicesEvents.DEVICE_LIST_CHANGED, 
                // @ts-ignore
                this.deviceChangeListener);
            }
            const { dispatch } = APP.store;
            return dispatch(getAvailableDevices())
                .then(() => {
                this.updateAudioIconEnabled();
                this.updateVideoIconEnabled();
            });
        }
        return Promise.resolve();
    },
    /**
     * Event listener for VietMeetMediaDevicesEvents.DEVICE_LIST_CHANGED to
     * handle change of available media devices.
     * @private
     * @param {MediaDeviceInfo[]} devices
     * @returns {Promise}
     */
    // @ts-ignore
    async _onDeviceListChanged(devices) {
        const state = APP.store.getState();
        const { filteredDevices, ignoredDevices } = filterIgnoredDevices(devices);
        const oldDevices = state['features/base/devices'].availableDevices;
        if (!areDevicesDifferent(flattenAvailableDevices(oldDevices), filteredDevices)) {
            return Promise.resolve();
        }
        logDevices(ignoredDevices, 'Ignored devices on device list changed:');
        const localAudio = getLocalVietMeetAudioTrack(state);
        const localVideo = getLocalVietMeetVideoTrack(state);
        APP.store.dispatch(updateDeviceList(filteredDevices));
        // Firefox users can choose their preferred device in the gUM prompt. In that case
        // we should respect that and not attempt to switch to the preferred device from
        // our settings.
        const newLabelsOnly = mediaDeviceHelper.newDeviceListAddedLabelsOnly(oldDevices, filteredDevices);
        const newDevices = mediaDeviceHelper.getNewMediaDevicesAfterDeviceListChanged(filteredDevices, localVideo, localAudio, newLabelsOnly);
        const promises = [];
        const requestedInput = {
            audio: Boolean(newDevices.audioinput),
            video: Boolean(newDevices.videoinput)
        };
        if (typeof newDevices.audiooutput !== 'undefined') {
            const { dispatch } = APP.store;
            const setAudioOutputPromise = setAudioOutputDeviceId(newDevices.audiooutput, dispatch)
                .catch(err => {
                logger.error(`Failed to set the audio output device to ${newDevices.audiooutput} - ${err}`);
            });
            promises.push(setAudioOutputPromise);
        }
        // Handles the use case when the default device is changed (we are always stopping the streams because it's
        // simpler):
        // If the default device is changed we need to first stop the local streams and then call GUM. Otherwise GUM
        // will return a stream using the old default device.
        if (requestedInput.audio && localAudio) {
            localAudio.stopStream();
        }
        if (requestedInput.video && localVideo) {
            localVideo.stopStream();
        }
        // Let's handle unknown/non-preferred devices
        const newAvailDevices = APP.store.getState()['features/base/devices'].availableDevices;
        let newAudioDevices = [];
        let oldAudioDevices = [];
        if (typeof newDevices.audiooutput === 'undefined') {
            // @ts-ignore
            newAudioDevices = newAvailDevices.audioOutput;
            // @ts-ignore
            oldAudioDevices = oldDevices.audioOutput;
        }
        if (!requestedInput.audio) {
            newAudioDevices = newAudioDevices.concat(newAvailDevices.audioInput);
            oldAudioDevices = oldAudioDevices.concat(oldDevices.audioInput);
        }
        // check for audio
        if (newAudioDevices.length > 0) {
            APP.store.dispatch(checkAndNotifyForNewDevice(newAudioDevices, oldAudioDevices));
        }
        // check for video
        if (requestedInput.video) {
            // @ts-ignore
            APP.store.dispatch(checkAndNotifyForNewDevice(newAvailDevices.videoInput, oldDevices.videoInput));
        }
        // When the 'default' mic needs to be selected, we need to pass the real device id to gUM instead of 'default'
        // in order to get the correct MediaStreamTrack from chrome because of the following bug.
        // https://bugs.chromium.org/p/chromium/issues/detail?id=997689
        const hasDefaultMicChanged = newDevices.audioinput === 'default';
        // When the local video is muted and a preferred device is connected, update the settings and remove the track
        // from the conference. A new track will be created and replaced when the user unmutes their camera.
        if (requestedInput.video && this.isLocalVideoMuted()) {
            APP.store.dispatch(updateSettings({
                cameraDeviceId: newDevices.videoinput
            }));
            requestedInput.video = false;
            delete newDevices.videoinput;
            // Remove the track from the conference.
            if (localVideo) {
                await this.useVideoStream(null);
                logger.debug('_onDeviceListChanged: Removed the current video track.');
            }
        }
        // When the local audio is muted and a preferred device is connected, update the settings and remove the track
        // from the conference. A new track will be created and replaced when the user unmutes their mic.
        if (requestedInput.audio && this.isLocalAudioMuted()) {
            APP.store.dispatch(updateSettings({
                micDeviceId: newDevices.audioinput
            }));
            requestedInput.audio = false;
            delete newDevices.audioinput;
            // Remove the track from the conference.
            if (localAudio) {
                await this.useAudioStream(null);
                logger.debug('_onDeviceListChanged: Removed the current audio track.');
            }
        }
        // Create the tracks and replace them only if the user is unmuted.
        if (requestedInput.audio || requestedInput.video) {
            let tracks = [];
            const realAudioDeviceId = hasDefaultMicChanged
                ? getDefaultDeviceId(APP.store.getState(), 'audioInput') : newDevices.audioinput;
            try {
                tracks = await mediaDeviceHelper.createLocalTracksAfterDeviceListChanged(createLocalTracksF, requestedInput.video ? newDevices.videoinput : null, requestedInput.audio ? realAudioDeviceId : null);
            }
            catch (error) {
                logger.error(`Track creation failed on device change, ${error}`);
                return Promise.reject(error);
            }
            for (const track of tracks) {
                if (track.isAudioTrack()) {
                    promises.push(this.useAudioStream(track)
                        .then(() => {
                        hasDefaultMicChanged && (track._realDeviceId = track.deviceId = 'default');
                    }));
                }
                else {
                    promises.push(this.useVideoStream(track));
                }
            }
        }
        return Promise.all(promises)
            .then(() => {
            this.updateAudioIconEnabled();
            this.updateVideoIconEnabled();
        });
    },
    /**
     * Determines whether or not the audio button should be enabled.
     */
    updateAudioIconEnabled() {
        const localAudio = getLocalVietMeetAudioTrack(APP.store.getState());
        const audioMediaDevices = APP.store.getState()['features/base/devices'].availableDevices.audioInput;
        const audioDeviceCount = audioMediaDevices ? audioMediaDevices.length : 0;
        // The audio functionality is considered available if there are any
        // audio devices detected or if the local audio stream already exists.
        const available = audioDeviceCount > 0 || Boolean(localAudio);
        APP.store.dispatch(setAudioAvailable(available));
    },
    /**
     * Determines whether or not the video button should be enabled.
     */
    updateVideoIconEnabled() {
        const videoMediaDevices = APP.store.getState()['features/base/devices'].availableDevices.videoInput;
        const videoDeviceCount = videoMediaDevices ? videoMediaDevices.length : 0;
        const localVideo = getLocalVietMeetVideoTrack(APP.store.getState());
        // The video functionality is considered available if there are any
        // video devices detected or if there is local video stream already
        // active which could be either screensharing stream or a video track
        // created before the permissions were rejected (through browser
        // config).
        const available = videoDeviceCount > 0 || Boolean(localVideo);
        APP.store.dispatch(setVideoAvailable(available));
        APP.API.notifyVideoAvailabilityChanged(available);
    },
    /**
     * Disconnect from the conference and optionally request user feedback.
     * @param {boolean} [requestFeedback=false] if user feedback should be
     * @param {string} [hangupReason] the reason for leaving the meeting
     * requested
     * @param {boolean} [notifyOnConferenceTermination] whether to notify
     * the user on conference termination
     */
    // @ts-ignore
    hangup(requestFeedback = false, hangupReason, notifyOnConferenceTermination) {
        APP.store.dispatch(disableReceiver());
        this._stopProxyConnection();
        this._stopExternalShare();
        APP.store.dispatch(destroyLocalTracks());
        this._localTracksInitialized = false;
        // Remove unnecessary event listeners from firing callbacks.
        // @ts-ignore
        if (this.deviceChangeListener) {
            VietMeetJS.mediaDevices.removeEventListener(VietMeetMediaDevicesEvents.DEVICE_LIST_CHANGED, 
            // @ts-ignore
            this.deviceChangeListener);
        }
        let feedbackResultPromise = Promise.resolve({});
        if (requestFeedback) {
            const feedbackDialogClosed = (feedbackResult = {}) => {
                // @ts-ignore
                if (!feedbackResult.wasDialogShown && hangupReason && notifyOnConferenceTermination) {
                    return APP.store.dispatch(openLeaveReasonDialog(hangupReason)).then(() => feedbackResult);
                }
                return Promise.resolve(feedbackResult);
            };
            feedbackResultPromise
                // @ts-ignore
                = APP.store.dispatch(maybeOpenFeedbackDialog(room, hangupReason))
                    .then(feedbackDialogClosed, feedbackDialogClosed);
        }
        const leavePromise = this.leaveRoom().catch(() => Promise.resolve());
        Promise.allSettled([feedbackResultPromise, leavePromise]).then(([feedback, _]) => {
            // @ts-ignore
            this._room = undefined;
            room = undefined;
            /**
             * Don't call {@code notifyReadyToClose} if the promotional page flag is set
             * and let the page take care of sending the message, since there will be
             * a redirect to the page anyway.
             */
            if (!interfaceConfig.SHOW_PROMOTIONAL_CLOSE_PAGE) {
                APP.API.notifyReadyToClose();
            }
            // @ts-ignore
            APP.store.dispatch(maybeRedirectToWelcomePage(feedback.value ?? {}));
        });
    },
    /**
     * Leaves the room.
     *
     * @param {boolean} doDisconnect - Whether leaving the room should also terminate the connection.
     * @param {string} reason - reason for leaving the room.
     * @returns {Promise}
     */
    leaveRoom(doDisconnect = true, reason = '') {
        // @ts-ignore
        APP.store.dispatch(conferenceWillLeave(room));
        const maybeDisconnect = () => {
            if (doDisconnect) {
                return disconnect();
            }
        };
        // @ts-ignore
        if (room?.isJoined()) {
            return room.leave(reason).then(() => maybeDisconnect())
                // @ts-ignore
                .catch(e => {
                logger.error(e);
                return maybeDisconnect();
            });
        }
        return maybeDisconnect();
    },
    /**
     * Changes the email for the local user
     * @param email {string} the new email
     */
    changeLocalEmail(email = '') {
        const formattedEmail = String(email).trim();
        APP.store.dispatch(updateSettings({
            email: formattedEmail
        }));
        sendData(commands.EMAIL, formattedEmail);
    },
    /**
     * Changes the avatar url for the local user
     * @param url {string} the new url
     */
    changeLocalAvatarUrl(url = '') {
        const formattedUrl = String(url).trim();
        APP.store.dispatch(updateSettings({
            avatarURL: formattedUrl
        }));
        sendData(commands.AVATAR_URL, url);
    },
    /**
     * Sends a message via the data channel.
     * @param {string} to the id of the endpoint that should receive the
     * message. If "" - the message will be sent to all participants.
     * @param {object} payload the payload of the message.
     * @throws NetworkError or InvalidStateError or Error if the operation
     * fails.
     */
    // @ts-ignore
    sendEndpointMessage(to, payload) {
        // @ts-ignore
        room.sendEndpointMessage(to, payload);
    },
    /**
     * Callback invoked by the external api create or update a direct connection
     * from the local client to an external client.
     *
     * @param {Object} event - The object containing information that should be
     * passed to the {@code ProxyConnectionService}.
     * @returns {void}
     */
    // @ts-ignore
    onProxyConnectionEvent(event) {
        // @ts-ignore
        if (!this._proxyConnection) {
            // @ts-ignore
            this._proxyConnection = new VietMeetJS.ProxyConnectionService({
                /**
                 * Pass the {@code VietMeetConnection} instance which will be used
                 * to fetch TURN credentials.
                 */
                // @ts-ignore
                jitsiConnection: APP.connection,
                /**
                 * The proxy connection feature is currently tailored towards
                 * taking a proxied video stream and showing it as a local
                 * desktop screen.
                 */
                convertVideoToDesktop: true,
                /**
                 * Callback invoked when the connection has been closed
                 * automatically. Triggers cleanup of screensharing if active.
                 *
                 * @returns {void}
                 */
                onConnectionClosed: () => {
                    if (this._untoggleScreenSharing) {
                        // @ts-ignore
                        this._untoggleScreenSharing();
                    }
                },
                /**
                 * Callback invoked to pass messages from the local client back
                 * out to the external client.
                 *
                 * @param {string} peerJid - The jid of the intended recipient
                 * of the message.
                 * @param {Object} data - The message that should be sent. For
                 * screensharing this is an iq.
                 * @returns {void}
                 */
                // @ts-ignore
                onSendMessage: (peerJid, data) => APP.API.sendProxyConnectionEvent({
                    data,
                    to: peerJid
                }),
                /**
                 * Callback invoked when the remote peer of the proxy connection
                 * has provided a video stream, intended to be used as a local
                 * desktop stream.
                 *
                 * @param {VietMeetLocalTrack} remoteProxyStream - The media
                 * stream to use as a local desktop stream.
                 * @returns {void}
                 */
                // @ts-ignore
                onRemoteStream: desktopStream => {
                    if (desktopStream.videoType !== 'desktop') {
                        logger.warn('Received a non-desktop stream to proxy.');
                        desktopStream.dispose();
                        return;
                    }
                    APP.store.dispatch(toggleScreensharingA(undefined, false, { desktopStream }));
                }
            });
        }
        // @ts-ignore
        this._proxyConnection.processMessage(event);
    },
    /**
     * Handle a direct-cast screenshare signalling message from a remote sharer.
     *
     * Direct-cast is the successor to the {@code ProxyConnectionService} path above: a
     * remote sharer (e.g. a laptop) opens a PLAIN RTCPeerConnection straight to this
     * VietMeet Meet instance and adds its screen — and optionally system audio — tracks.
     * {@link ExternalShareReceiver} terminates that peer connection here and VietMeet moves
     * the received track(s) into the conference as the local screenshare. No
     * ProxyConnectionService, no Jingle, no XMPP/Strophe JIDs, and audio comes along for
     * free.
     *
     * @param {Object} signal - The signalling message ({ kind, sdp | candidate }).
     * @returns {void}
     */
    // @ts-ignore
    onExternalShareSignal(signal) {
        // A fresh offer begins a new cast session. If a receiver is already around (a
        // second/reconnecting sharer, or a stale one whose PC died), tear it down first
        // rather than feeding the new offer into the old — possibly already-published —
        // peer connection, where _publish's once-only guard would swallow it.
        // Optional chaining: signal is embedder-supplied, so it may be malformed/absent.
        if (signal?.kind === 'offer') {
            this._stopExternalShare();
        }
        // @ts-ignore
        if (!this._externalShare) {
            // @ts-ignore
            this._externalShare = new ExternalShareReceiver({
                // Reuse the meeting's own TURN credentials — the same source the old
                // proxy borrowed — minus the XMPP signalling.
                // @ts-ignore
                pcConfig: APP.connection?.xmpp?.connection?.jingle?.p2pIceConfig,
                // @ts-ignore
                onSignal: out => APP.API.sendExternalShareSignal(out),
                // @ts-ignore
                onTracks: ({ desktopVideoTrack, desktopAudioTrack }) => {
                    APP.store.dispatch(toggleScreensharingA(true, false, {
                        desktopStream: desktopVideoTrack,
                        desktopAudioTrack
                    }));
                },
                // @ts-ignore
                onClosed: ({ spontaneous, published } = {}) => {
                    // If the sharer's connection dropped on its own (ICE failure, laptop
                    // closed, sharer navigated away) while a share was live, the published
                    // screenshare is now frozen in the meeting — take it down. Explicit
                    // teardowns (hangup / _stopExternalShare) are driven from the conference
                    // and remove the share through their own path, so we skip it there.
                    if (spontaneous && published) {
                        APP.store.dispatch(toggleScreensharingA(false, false));
                    }
                    // @ts-ignore
                    this._externalShare = null;
                }
            });
        }
        // @ts-ignore
        this._externalShare.handleSignal(signal);
    },
    /**
     * Terminates any direct-cast screenshare connection that is active.
     *
     * @private
     * @returns {void}
     */
    _stopExternalShare() {
        // @ts-ignore
        if (this._externalShare) {
            // @ts-ignore
            this._externalShare.stop();
        }
        // @ts-ignore
        this._externalShare = null;
    },
    /**
     * Sets the video muted status.
     */
    setVideoMuteStatus() {
        APP.UI.setVideoMuted(this.getMyUserId());
    },
    /**
     * Dispatches the passed in feedback for submission. The submitted score
     * should be a number inclusively between 1 through 5, or -1 for no score.
     *
     * @param {number} score - a number between 1 and 5 (inclusive) or -1 for no
     * score.
     * @param {string} message - An optional message to attach to the feedback
     * in addition to the score.
     * @returns {void}
     */
    submitFeedback(score = -1, message = '') {
        if (score === -1 || (score >= 1 && score <= 5)) {
            // @ts-ignore
            APP.store.dispatch(submitFeedback(score, message, room));
        }
    },
    /**
     * Terminates any proxy screensharing connection that is active.
     *
     * @private
     * @returns {void}
     */
    _stopProxyConnection() {
        // @ts-ignore
        if (this._proxyConnection) {
            // @ts-ignore
            this._proxyConnection.stop();
        }
        // @ts-ignore
        this._proxyConnection = null;
    }
};
